// ARCHIVO: src/components/PreloadSpinner.jsx
// UBICACIÓN: C:\xampp\htdocs\sf3\ventas\src\components\PreloadSpinner.jsx
// DESCRIPCIÓN: Componente de preload unificado para todas las páginas

import React from 'react';

const PreloadSpinner = ({ size = 'large', className = '' }) => {
  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'h-8 w-8';
      case 'medium':
        return 'h-12 w-12';
      case 'large':
        return 'h-16 w-16';
      case 'xl':
        return 'h-20 w-20';
      default:
        return 'h-16 w-16';
    }
  };

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <div className={`animate-spin rounded-full border-b-2 border-blue-600 ${getSizeClasses()}`}></div>
    </div>
  );
};

export default PreloadSpinner;
